/* measure-ui.js — Carte « Mesures » : trois mesures lancées dans un Worker, du
 * plus rapide au plus coûteux (paquets, niveau sonore, image). Les valeurs
 * rejoignent le modèle, que la fiche et les règles relisent aussitôt.
 * Expose window.Measure. */
(function () {
  'use strict';

  var F = window.MediaFormat;
  var K = window.MediaFindings;
  var L = K.LABELS;

  var host = document.getElementById('measure');
  var worker = null;
  var jobId = 0;
  var file = null;

  // Un état par mesure ; une seule tourne à la fois.
  function blank() { return { state: 'idle', data: null, progress: 0, message: '' }; }
  var subs = { measure: blank(), loudness: blank(), picture: blank() };

  function ensureWorker() {
    if (worker) return worker;
    worker = new Worker(new URL('./workers/packets.worker.js', import.meta.url), { type: 'module' });
    worker.onmessage = function (e) {
      var m = e.data || {};
      if (m.jobId !== jobId) return;
      var running = active();
      if (m.type === 'progress') { if (running) running.progress = m.progress; render(); return; }
      if (m.type === 'cancelled') { Object.keys(subs).forEach(function (k) { if (subs[k].state === 'running') subs[k] = blank(); }); render(); return; }
      if (m.type === 'error') {
        if (running) { running.state = 'error'; running.message = m.error; }
        render(); return;
      }
      var key = { result: 'measure', loudness: 'loudness', picture: 'picture' }[m.type];
      if (!key) return;
      subs[key].state = 'done';
      subs[key].data = m.result;
      render();
      publish(m.result.values);
    };
    worker.onerror = function (ev) {
      var running = active();
      if (running) { running.state = 'error'; running.message = ev.message || 'Mesure impossible.'; }
      render();
    };
    return worker;
  }

  function active() {
    var keys = Object.keys(subs);
    for (var i = 0; i < keys.length; i++) if (subs[keys[i]].state === 'running') return subs[keys[i]];
    return null;
  }

  // Entrent dans le modèle, puis la page se redessine.
  function publish(values) {
    if (!values || !values.length || !window.App) return;
    window.App.addMeasured(values);
  }

  function start(kind) {
    if (!file || active()) return;
    jobId++;
    subs[kind] = { state: 'running', data: null, progress: 0, message: '' };
    render();
    ensureWorker().postMessage({ type: kind, file: file, jobId: jobId });
  }

  function cancel() {
    if (worker) worker.postMessage({ type: 'cancel' });
    Object.keys(subs).forEach(function (k) { if (subs[k].state === 'running') subs[k] = blank(); });
    render();
  }

  /* ---------- Rendu ---------- */

  // Débit seconde par seconde, en SVG.
  function sparkline(series) {
    if (!series || series.length < 2) return '';
    var w = 640, h = 90;
    var max = Math.max.apply(null, series.map(function (p) { return p.bytes; })) || 1;
    var last = series[series.length - 1].second || 1;
    var pts = series.map(function (p) {
      var x = (p.second / last) * w;
      var y = h - (p.bytes / max) * (h - 6) - 3;
      return Math.round(x * 10) / 10 + ',' + Math.round(y * 10) / 10;
    }).join(' ');
    return '<svg class="spark" viewBox="0 0 ' + w + ' ' + h + '" preserveAspectRatio="none" role="img" ' +
      'aria-label="Débit seconde par seconde">' +
      '<polyline points="' + pts + '" fill="none" stroke="currentColor" stroke-width="1.5" />' +
      '</svg>';
  }

  function kpi(label, value) {
    return value == null || value === '' ? ''
      : '<div class="kpi"><span class="kpi-lbl">' + F.esc(label) + '</span><span class="kpi-val">' + F.esc(value) + '</span></div>';
  }

  function running(sub) {
    return '<p class="card-sub">' + F.esc(L.measuring) + '</p>' +
      '<progress value="' + Math.round(sub.progress * 100) + '" max="100"></progress> ' +
      '<button type="button" class="act tiny secondary" data-measure-cancel>' + F.esc(L.measureCancel) + '</button>';
  }

  function button(kind, label, size) {
    return '<button type="button" class="act ' + (size || 'tiny secondary') + '" data-run="' + kind + '">' + F.esc(label) + '</button>';
  }

  function packetsHtml() {
    var result = subs.measure.data;
    var fr = result.frameRate, kf = result.keyframes;
    function v(property, where) {
      return (result.values.filter(function (x) {
        return x.property === property && (!where || x.subject.kind === where);
      })[0] || {}).value;
    }
    var kpis = kpi('Cadence', fr ? String(fr.fps).replace('.', ',') + ' i/s' : null) +
      kpi('Constance', fr ? (fr.mode === 'CFR' ? 'constante' : 'variable') : null) +
      kpi('Débit réel', F.valueText('bitRate', v('bitRate', 'video'))) +
      kpi('Pointe', F.valueText('peakBitRate', v('peakBitRate'))) +
      kpi('Images clés', kf && kf.max != null ? F.valueText('keyframeInterval', kf.max) : null) +
      kpi('Décalage A/V', v('avOffset') == null ? null : F.valueText('avOffset', v('avOffset')));
    var note = fr && fr.mode === 'VFR'
      ? '<p class="card-sub">Cadence variable : ' + fr.irregular + ' écart(s) irrégulier(s) sur ' + fr.total + '.</p>' : '';
    return '<div class="kpi-row">' + kpis + '</div>' + note + sparkline(result.series) +
      '<p class="card-sub">Débit seconde par seconde, de 0 à ' + F.esc(F.fmt.duration(result.duration) || '') + '.</p>';
  }

  // Son propre bouton : le niveau sonore demande de décoder.
  function loudnessHtml() {
    var sub = subs.loudness;
    if (sub.state === 'running') return '<div class="loud">' + running(sub) + '</div>';
    var head = '<p class="card-sub">' + F.esc(L.loudnessNote) + '</p>';
    if (sub.state === 'done' && sub.data) {
      var kpis = sub.data.tracks.map(function (t) {
        var name = sub.data.tracks.length > 1 ? 'Audio ' + t.ordinal + ' — ' : '';
        return kpi(name + 'Niveau intégré', F.valueText('loudnessIntegrated', t.result.integrated)) +
          kpi(name + 'Plage', t.result.range == null ? null : F.valueText('loudnessRange', t.result.range)) +
          kpi(name + 'Crête vraie', F.valueText('truePeak', t.result.truePeak));
      }).join('');
      return '<div class="loud">' + head + '<div class="kpi-row">' + kpis + '</div>' +
        button('loudness', L.loudnessAgain) + '</div>';
    }
    return '<div class="loud">' + head +
      (sub.state === 'error' ? '<p class="cmd-warn">' + F.esc(sub.message) + '</p>' : '') +
      button('loudness', L.loudnessRun) + '</div>';
  }

  var SCAN_TEXT = {
    progressive: 'scanProgressive', interlaced: 'scanInterlaced',
    telecine: 'scanTelecine', partial: 'scanPartial'
  };

  // Ce que le balayage mesuré implique : la correction diffère selon le cas.
  function scanNote(scan) {
    if (scan.mode === 'interlaced') {
      return 'Les images portent un peigne : le fichier est bel et bien entrelacé, quoi qu’en dise le champ « type de balayage ». Il faut le désentrelacer avant toute diffusion sur le web.';
    }
    if (scan.mode === 'telecine') {
      return 'Le peigne revient sur deux images toutes les cinq : c’est un film à 24 images transposé en vidéo à 30. À ne pas désentrelacer — il faut défaire le télécinéma, ce qui rend au film ses 24 images d’origine, sans perte de netteté.';
    }
    if (scan.mode === 'partial') {
      return 'Une partie des images seulement est peignée (' + scan.combed + ' sur ' + scan.frames +
        ') : sans doute un montage qui mêle des sources de natures différentes. À regarder de plus près avant de corriger quoi que ce soit.';
    }
    return null;
  }

  function pictureHtml() {
    var sub = subs.picture;
    if (sub.state === 'running') return '<div class="loud">' + running(sub) + '</div>';
    var head = '<p class="card-sub">' + F.esc(L.pictureNote) + '</p>';
    if (sub.state === 'done' && sub.data) {
      var res = sub.data.result;
      if (!res) return '<div class="loud">' + head + '<p class="card-sub">' + F.esc(L.pictureNone) + '</p></div>';
      var bars = res.bars, active = res.active, scan = res.scan;
      var sides = [];
      if (bars) {
        if (bars.top >= 4) sides.push('haut ' + bars.top + ' px');
        if (bars.bottom >= 4) sides.push('bas ' + bars.bottom + ' px');
        if (bars.left >= 4) sides.push('gauche ' + bars.left + ' px');
        if (bars.right >= 4) sides.push('droite ' + bars.right + ' px');
      }
      var scanKey = SCAN_TEXT[scan.mode];
      var kpis = kpi('Image utile', active ? active.width + ' × ' + active.height + ' px' : null) +
        kpi('Format réel', active && active.aspect ? F.valueText('activeAspectRatio', active.aspect) : null) +
        kpi('Bandes noires', sides.length ? sides.join(' · ') : 'aucune') +
        (sides.length ? kpi('Part du cadre perdue', F.valueText('barsShare', res.barsShare)) : '') +
        kpi('Balayage', scanKey ? L[scanKey] : L.scanStill);
      var notes = '<p class="card-sub">Mesuré sur ' + scan.frames + ' image(s) décodée(s)' +
        (scan.combed ? ', dont ' + scan.combed + ' peignée(s)' : '') +
        (sides.length ? ' · les bandes annoncées sont noires sur les ' + bars.frames + ' images examinées' : '') + '.</p>';
      var advice = scanNote(scan);
      if (advice) notes += '<p class="cmd-warn">' + F.esc(advice) + '</p>';
      return '<div class="loud">' + head + '<div class="kpi-row">' + kpis + '</div>' + notes +
        button('picture', L.pictureAgain) + '</div>';
    }
    return '<div class="loud">' + head +
      (sub.state === 'error' ? '<p class="cmd-warn">' + F.esc(sub.message) + '</p>' : '') +
      button('picture', L.pictureRun) + '</div>';
  }

  function render() {
    if (!host) return;
    if (!file) { host.innerHTML = ''; return; }
    var sub = subs.measure, body;
    if (sub.state === 'running') body = running(sub);
    else if (sub.state === 'done' && sub.data) body = packetsHtml() + button('measure', L.measureAgain);
    else if (sub.state === 'error') body = '<p class="cmd-warn">' + F.esc(sub.message) + '</p>' + button('measure', L.measureRun);
    else body = button('measure', L.measureRun, 'act');
    host.innerHTML = '<section class="block measure" id="measureBlock" aria-labelledby="measureTitle">' +
      '<header class="block-head"><h3 class="block-title" id="measureTitle">' + F.esc(L.measureTitle) + '</h3>' +
      '<p class="block-lede">' + F.esc(L.measureLede) + '</p></header>' +
      '<div class="block-body">' + body + loudnessHtml() + pictureHtml() + '</div></section>';
  }

  if (host) {
    host.addEventListener('click', function (e) {
      var run = e.target.closest('[data-run]');
      if (run) start(run.getAttribute('data-run'));
      else if (e.target.closest('[data-measure-cancel]')) cancel();
    });
  }

  function reset() {
    subs = { measure: blank(), loudness: blank(), picture: blank() };
    jobId++;
  }

  window.Measure = {
    setFile: function (f) { file = f; reset(); render(); },
    reset: function () { file = null; reset(); render(); }
  };
})();
